export default __webpack_public_path__ + "static/media/NotoSans-ExtraBold.a3f3d853.woff";